import { render } from "./Highlight.vue?vue&type=template&id=6fe8debb"
import script from "./Highlight.vue?vue&type=script&lang=ts"
export * from "./Highlight.vue?vue&type=script&lang=ts"

import "./Highlight.vue?vue&type=style&index=0&id=6fe8debb&lang=scss"
script.render = render

export default script